import request from '../../domain/utils/request'
import { getService } from '../../parameters'
import { getBIParams } from '../../domain/analytics/BiTagger'
import { bboxToSearchParameter } from '../../domain/map/conversion'
import SERVICES from '../../services.constants'

export const requestSuggest = (getState, { terms, suggestFilterType = 'all' }) => {
  const service = getService(SERVICES.SUGGEST)
  const params = {
    q: terms,
    filter: suggestFilterType,
    limit: 5,
    focus_bbox: bboxToSearchParameter(getState().map.bbox),
    ...getBIParams()
  }

  return request.get(service, { params }).then(response => response)
}
